import type * as React from 'react';
import { del } from '@Domain/Api';
import roleDeleted, { type RoleDeletedAction } from '@Application/Security/Roles/Actions/roleDeleted';
import roleDeletionFailed, {
	type RoleDeletionFailedAction,
} from '@Application/Security/Roles/Actions/roleDeletionFailed';
import type DeleteRole from '@Application/Security/Roles/Commands/DeleteRole';
import fetchRoles from '@Application/Security/Roles/fetchRoles';
import FetchRoles from '@Application/Security/Roles/Queries/FetchRoles';
import type { RolesFetchedAction } from '@Application/Security/Roles/Actions/rolesFetched';
import type { RolesFetchFailedAction } from '@Application/Security/Roles/Actions/rolesFetchFailed';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = RoleDeletedAction | RoleDeletionFailedAction | RolesFetchedAction | RolesFetchFailedAction;

/** `204` carries no list, so it is refetched; a failed refetch is ignored. */
export default (command: DeleteRole) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/roles/${command.roleId}`,
			);

			const action = roleDeleted({ roleId: command.roleId }, command.accountId);
			dispatch(action);
			await fetchRoles(new FetchRoles(command.accountId))(dispatch).catch(() => undefined);

			return action;
		} catch (error) {
			const action = roleDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
